import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import MemberRoute from "./components/admin/MemberRoute";
import AdminLayout from "./components/admin/AdminLayout";
import { GlobalFX } from "./components/ui/Fx";
import ScrollToTop from "./components/ui/ScrollToTop";

// Public pages
import HomePage from "./pages/public/HomePage";
import AboutPage from "./pages/public/AboutPage";
import PostListPage from "./pages/public/PostListPage";
import PostDetailPage from "./pages/public/PostDetailPage";
import ContactPage from "./pages/public/ContactPage";
import NotFoundPage from "./pages/public/NotFoundPage";
import AuthPage from "./pages/public/AuthPage";
import MemberDashboard from "./pages/public/MemberDashboard";
import ProfilePage from "./pages/public/ProfilePage";

// Admin pages
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPostsList from "./pages/admin/AdminPostsList";
import AdminPostEditor from "./pages/admin/AdminPostEditor";
import AdminUploads from "./pages/admin/AdminUploads";
import AdminNewsletter from "./pages/admin/AdminNewsletter";
import AdminMembers from "./pages/admin/AdminMembers";

function PublicLayout({ children }) {
  return (
    <>
      <GlobalFX />
      <Navbar />
      <main style={{ minHeight: "100vh" }}>
        {children}
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* ── PUBLIC ROUTES ── */}
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />

          {/* ── AUTH ROUTES ── */}
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/admin/login" element={<AuthPage mode="login" />} />

          {/* ── MEMBER ONLY ROUTES ── */}
          <Route path="/insights" element={<PublicLayout><MemberRoute><PostListPage type="insights" /></MemberRoute></PublicLayout>} />
          <Route path="/insights/:slug" element={<PublicLayout><MemberRoute><PostDetailPage /></MemberRoute></PublicLayout>} />

          <Route path="/weekly-outlook" element={<PublicLayout><MemberRoute><PostListPage type="weekly-outlook" /></MemberRoute></PublicLayout>} />
          <Route path="/weekly-outlook/:slug" element={<PublicLayout><MemberRoute><PostDetailPage /></MemberRoute></PublicLayout>} />

          <Route path="/trade-ideas" element={<PublicLayout><MemberRoute><PostListPage type="trade-ideas" /></MemberRoute></PublicLayout>} />
          <Route path="/trade-ideas/:slug" element={<PublicLayout><MemberRoute><PostDetailPage /></MemberRoute></PublicLayout>} />

          <Route path="/education" element={<PublicLayout><MemberRoute><PostListPage type="education" /></MemberRoute></PublicLayout>} />
          <Route path="/education/:slug" element={<PublicLayout><MemberRoute><PostDetailPage /></MemberRoute></PublicLayout>} />

          <Route path="/profile" element={<PublicLayout><MemberRoute><ProfilePage /></MemberRoute></PublicLayout>} />
          <Route path="/dashboard" element={<PublicLayout><MemberDashboard /></PublicLayout>} />

          {/* ── PROTECTED ADMIN ROUTES ── */}
          <Route path="/admin" element={<ProtectedRoute><AdminLayout><AdminDashboard /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/posts" element={<ProtectedRoute><AdminLayout><AdminPostsList /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/posts/new" element={<ProtectedRoute><AdminLayout><AdminPostEditor /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/posts/:id/edit" element={<ProtectedRoute><AdminLayout><AdminPostEditor /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/uploads" element={<ProtectedRoute><AdminLayout><AdminUploads /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/newsletter" element={<ProtectedRoute><AdminLayout><AdminNewsletter /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/members" element={<ProtectedRoute><AdminLayout><AdminMembers /></AdminLayout></ProtectedRoute>} />

          {/* 404 */}
          <Route path="*" element={<PublicLayout><NotFoundPage /></PublicLayout>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
